export default "__VITE_ASSET__DYomOMQQ__"